export type ConversationMode='auto'|'answer'|'materials'
export type ConversationAction='answer'|'materials'|'image'
/** Conservative routing only: users can override it; no model call is needed to
 * locate a file. An attached image is always the current turn's search input. */
export function conversationAction(text:string,mode:ConversationMode,hasImage:boolean,canSearch:boolean):ConversationAction{
 if(hasImage)return 'image'
 if(mode==='answer'||!canSearch)return 'answer'
 if(mode==='materials')return 'materials'
 const query=text.trim()
 if(/总结|概括|解释|解读|比较|对比|分析|支持|如何|怎么|为什么|为何|是什么|哪些功能|核心能力|不要|不必|不用|[?？]|\b(?:what|why|how|compare|explain)\b/i.test(query))return 'answer'
 if(/^(?:请\s*)?(?:帮我|给我)?\s*(?:搜索|查找|寻找|找一下|找找|搜一下|搜搜|搜|找|查询|检索)\s*\S/.test(query))return 'materials'
 if(/(?:有哪些|有什么|列出|罗列).{0,24}(?:资料|材料|文档|文件|素材|案例)|(?:资料|材料|文档|文件|素材).{0,8}(?:有哪些|有什么)/.test(query))return 'materials'
 if(query.length<=48&&/^(?:(?:B2[BC]|DTC|OMS|WMS|CRM|ERP|PIM|CDP|MES|SCM|SCRM)\b[\w\s./+&-]*|[\w\s./+&-]*(?:OMS|WMS|CRM|ERP)|(?:官网商城|商城|订单管理|仓储管理|会员管理|公司介绍)(?:方案|资料|材料|案例|架构图)?)$/i.test(query))return 'materials'
 return 'answer'
}
/** Resolve only explicit references to the last result's names. Descriptions
 * are not forwarded as evidence or asserted product capabilities. */
export function catalogFollowupPrompt(text:string,assets:readonly {name:string}[]):string{
 if(!assets.length)return text
 const digits:Record<string,number>={一:1,二:2,两:2,三:3,四:4,五:5,六:6,七:7,八:8}
 const token=text.match(/第([一二两三四五六七八\d]+)(?:份|个|项)/)?.[1]
 const index=token?(/^\d+$/.test(token)?Number(token):digits[token]??0)-1:-1
 const names=token?(assets[index]?[assets[index]!.name]:[]):/这些(?:资料|材料|文件|方案)|上述(?:资料|材料|文件|方案)/.test(text)?assets.slice(0,8).map(item=>item.name):assets.length===1&&/这份|该资料|这个方案/.test(text)?[assets[0]!.name]:[]
 return names.length?`${text}\n本轮所指资料：${names.map(name=>`《${name}》`).join('、')}。请基于当前可访问的生效基线回答。`:text
}
